import { GlassPillDirective } from "../../../general/directives/glass-pill.directive";
import { UserStats } from "../../../user/models/user.model";
import { ChangeDetectorRef, Component, OnInit, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { LoaderComponent } from "../../../general/components/loader/loader.component";
import { AuthService } from "../../../../core/services/auth.service";

@Component({
  selector: 'app-user-stats',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    LoaderComponent,
    GlassPillDirective
  ],
  templateUrl: './user-stats.component.html',
  styleUrl: './user-stats.component.scss',
})
export class UserStatsComponent implements OnInit {
    private cdr = inject(ChangeDetectorRef);
    private auth = inject(AuthService);

    stats?: UserStats;

    ngOnInit(): void {
        this.auth.getUserStats().subscribe(stats => {
            this.stats = stats;
            this.cdr.detectChanges();
        });
    }
}